// removed by extract-text-webpack-plugin
module.exports = {"text":"text-1H3Pf","link":"link-1Wman","button":"button-2n5U3","buttondisabled":"buttondisabled-fQCpa","menu":"menu-14vPD","divblock":"divblock-_Isla","th":"th-svB4i"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/zayavki-list/style.scss
 ** module id = 45
 ** module chunks = 0
 **/